import Vue from "vue";
import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
import {
  email,
  max,
  min,
  min_value,
  max_value,
  required,
  confirmed,
  double,
  numeric,
  alpha_num as alphaNum,
} from "vee-validate/dist/rules";

extend("required", {
  ...required,
  message: "This field is required",
});

extend("max", {
  ...max,
  message: "This field must be {length} characters or less",
});

extend("email", {
  ...email,
  message: "This field must be a valid email",
});

extend("min", {
  ...min,
  message: "This field must be {length} characters or more",
});

extend("confirmed", {
  ...confirmed,
  message: "Passwords mismatch",
});

extend("alpha_num", {
  ...alphaNum,
  message: "This field may contain only alpha-numeric characters",
});

extend("alpha_num_space", {
  validate: (value) => {
    return /^[\w\s]*$/i.test(value);
  },
  message: "This field may contain only alpha-numeric and space characters",
});

extend("min_value", {
  ...min_value,
  message: "The field must be {min} or more",
});

extend("max_value", {
  ...max_value,
  message: "The field must be {max} or less",
});

extend("numeric", {
  ...numeric,
  message: "The field may only contain numeric characters",
});

extend("double", {
  ...double,
  message: "The field must be double",
});

extend("is_json", {
  message: "The field must be a valid JSON",
  validate: (value) => {
    if (typeof value !== "string") return false;
    try {
      const parsed = JSON.parse(value);
      return typeof parsed === "object";
    } catch {
      return false;
    }
  },
});

Vue.component("validation-provider", ValidationProvider);
Vue.component("validation-observer", ValidationObserver);
